import { isFunction, isUndefined } from 'mc-ui-utils';
import colors from '../styles/colors';
export const hasGlanceInterface = () => typeof window !== 'undefined' && !isUndefined(window.GlanceAndroidInterface);
export const setGlancePreference = (key, value) => {
    var _a;
    try {
        if (hasGlanceInterface()) {
            (_a = window.PreferencesStore) === null || _a === void 0 ? void 0 : _a.putString(key, value);
        }
        else {
            localStorage.setItem(key, value);
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getGlancePreference = (key, defaultValue = '') => {
    var _a;
    try {
        if (hasGlanceInterface()) {
            return (_a = window.PreferencesStore) === null || _a === void 0 ? void 0 : _a.getString(key, defaultValue);
        }
        return localStorage.getItem(key);
    }
    catch (err) {
        console.error(err);
    }
};
export const getFooterHeight = () => {
    var _a;
    try {
        if (hasGlanceInterface() &&
            isFunction((_a = window.GlanceAndroidInterface) === null || _a === void 0 ? void 0 : _a.getBottomOverlayHeight)) {
            return `${window.GlanceAndroidInterface.getBottomOverlayHeight() /
                window.devicePixelRatio}px`;
        }
        return `0`;
    }
    catch (err) {
        console.error(err);
    }
};
export const isUserOnline = () => {
    try {
        if (hasGlanceInterface()) {
            return window.AndroidUtils.isNetworkConnected();
        }
        return true;
    }
    catch (err) {
        console.error(err);
    }
};
export const getGlanceSdkVersion = () => {
    var _a;
    try {
        if (hasGlanceInterface() &&
            isFunction((_a = window.GlanceAndroidInterface) === null || _a === void 0 ? void 0 : _a.getGlanceSdkVersion)) {
            return window.GlanceAndroidInterface.getGlanceSdkVersion();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const getRegion = () => {
    var _a;
    try {
        if (hasGlanceInterface() &&
            isFunction((_a = window.GlanceAndroidInterface) === null || _a === void 0 ? void 0 : _a.getRegion)) {
            return window.GlanceAndroidInterface.getRegion();
        }
    }
    catch (err) {
        console.error(err);
    }
};
export const pingCustomAnalytics = (eventType, extras) => {
    var _a;
    try {
        console.debug(`%c Custom Analytics data via GlanceAndroidInterface: ${eventType} ${JSON.stringify(extras)}`, `background: ${colors.white}; color: ${colors.glanceRed};padding: 2px;`);
        if (hasGlanceInterface() &&
            isFunction((_a = window.GlanceAndroidInterface) === null || _a === void 0 ? void 0 : _a.sendCustomAnalyticsEvent)) {
            window.GlanceAndroidInterface.sendCustomAnalyticsEvent(eventType, JSON.stringify(extras));
        }
    }
    catch (error) {
        console.error(error);
    }
};
//# sourceMappingURL=glanceandroidbridge.js.map